  if(!customElements.get('product-subscription-plan')) {
    class ProductSubscriptionPlan extends HTMLElement {
      constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.sellingPlanWrapper = this.mainElement.querySelector('.selling-plan-wrapper');
        this.sellingPlanOption = this.sellingPlanWrapper.querySelectorAll('.selling-plan-option');
        this.sellingPlanOptionSubsave = this.mainElement.querySelector('.selling-plan-option--subsave .option-price');
        this.sellingPlanOptionOnetime = this.mainElement.querySelector('.selling-plan-option--onetime .option-price');
        this.productHiddenId = this.mainElement.querySelector('[data-variant-id]');
        this.subscriptionHiddenId = this.mainElement.querySelector('[data-subscription-variant-id]');
        this.purchaseOption = this.sellingPlanWrapper.querySelectorAll('input[name="purchase_option"]');
        this.subscriptionId = this.mainElement.querySelector('input[name="properties[subscription_id]"]');
        this.shippingIntervalFrequency = this.mainElement.querySelector('input[name="properties[shipping_interval_frequency]"]');
        this.shippingIntervalUnitType = this.mainElement.querySelector('input[name="properties[shipping_interval_unit_type]"]');
        this.caseQuantity = this.mainElement.querySelector('#case_quantity');
        this.caseCta = this.mainElement.querySelector('.case-cta');
        this.caseInfo = this.caseCta.querySelector('.info .quantity');
        this.caseFormat = this.caseCta.querySelector('.info .format');
        this.lastSelectedVariant = null;
        this.caseSize = this.caseInfo ? (this.caseInfo.textContent || 4) : null;
        this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
        if (this.subscriptionHiddenId) {
          this.productHiddenId.removeAttribute('name');
          this.mapping = JSON.parse(this.subscriptionHiddenId.dataset.variantMap);
        }
        this.variantId = this.productHiddenId.value;
        

        if(this.purchaseOption) this.purchaseOption.forEach(e => e.addEventListener('change', this.openChangeSubscription.bind(this)));
        this.caseQuantity.addEventListener('change', this.onChangeCases.bind(this));
        this.updateVariant();
      }

      onVariantChange(e) {
        this.updateVariant();
      }
      
      getLastSelectedVariant(){
        return this.lastSelectedVariant ? this.lastSelectedVariant : "discountVariantId";
      }

      updateVariant() {
        var variant = this.mainElement.getCurrentVariant();
        this.variantId = variant.id;
        this.discountVariantId = this.mapping[this.variantId].discount_variant_id;
        this.discountVariantPrice = this.mapping[this.variantId].discount_variant_price;
        this.sellingPlanOptionOnetime.dataset.price = variant.price;
        if (this.subscriptionHiddenId) {
          const lastSelectedVariant = this.getLastSelectedVariant();
          this.subscriptionHiddenId.value = this[lastSelectedVariant];
        }
        this.sellingPlanOptionSubsave.textContent = $s.formatMoney(this.discountVariantPrice).replace('.00', '');
        this.updatePrices();
        this.caseSize = this.mainElement.productData.productFormatQuantity[this.variantId].quantity;
        if (this.caseFormat) {
            this.caseFormat.innerHTML = this.mainElement.productData.productFormatQuantity[this.variantId].format;
        }
        this.onChangeCases();
      }
      

      openChangeSubscription(e) {
        this.sellingPlanOption.forEach(e => e.classList.remove('active'));
        e.target.parentNode.classList.toggle('active');
        
        if(e.target.value){
          this.subscriptionId.setAttribute('name', 'properties[subscription_id]');
          this.shippingIntervalFrequency.setAttribute('name', 'properties[shipping_interval_frequency]');
          this.shippingIntervalUnitType.setAttribute('name', 'properties[shipping_interval_unit_type]');
          this.subscriptionHiddenId.value = this.discountVariantId;
          this.lastSelectedVariant = "discountVariantId";
        } else {
          this.subscriptionHiddenId.value = this.variantId;
          this.lastSelectedVariant = "variantId";
          this.subscriptionId.removeAttribute('name');
          this.shippingIntervalFrequency.removeAttribute('name');
          this.shippingIntervalUnitType.removeAttribute('name');
        }
      }

      updatePrices() {
        this.sellingPlanOptionSubsave.textContent = $s.formatMoney(this.discountVariantPrice * this.caseQuantity.value * 100).replace('.00', '');
        this.sellingPlanOptionOnetime.textContent = $s.formatMoney(this.sellingPlanOptionOnetime.dataset.price * this.caseQuantity.value).replace('.00', '');
      }

      onChangeCases(e) {
          if (this.caseInfo) {
              this.caseInfo.textContent = this.caseQuantity.value * this.caseSize;
          }
        this.updatePrices();
      }
    }
    customElements.define('product-subscription-plan', ProductSubscriptionPlan);
  }